<template>
    <div class="rating-edit-header">
        <h3
            class="title"
            :class="ratingIn && 'order-1 order-sm-0'">
            {{ ratingIn.title }}
        </h3>

        <div
            class="rating-edit-tools order-0 order-sm-1"
            v-if="ratingIn">
            <div class="context-nav context-nav-main-rating">
                <b-dropdown
                    class="ellipsis-nav rating-nav"
                    no-caret
                    variant="primary"
                    right
                    toggle-class="rating-edit-context-menu">
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                        class="edit-rating-title"
                        v-b-modal="'rating-title-edit-modal'"
                        @click="$event.stopPropagation()">
                        <i class="btn-edit"></i>{{ $t('rating.change_name') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        class="remove-rating-form"
                        @click.prevent.stop="removeRating">
                        <i class="btn-remove"></i>Verwijder beoordelingsformulier
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <design-2021-rating-title-edit-modal :rating-in="ratingIn"></design-2021-rating-title-edit-modal>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rating-edit-title-component',
    props: {
        ratingIn: {
            type: Object,
            require: true,
        },
        groupId: {
            type: Number,
            require: true,
        },
    },

    methods: {
        removeRating() {
            this.alert
                .confirm(
                    'Formulier verwijderen',
                    'Weet je zeker dat je dit formulier wil verwijderen? Je zult het formulier voor alle groepen verwijderen!',
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete(this.routes.ratingDelete(this.ratingIn.id)).then(
                            (response) => {
                                this.alert.success();
                                window.location.href = this.routes.groupShow(this.groupId);
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.rating-edit-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    flex: 1 0 100%;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .title {
        font-weight: $font-weight-bold;
        margin-bottom: 0;

        .deadline {
            margin-top: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .rating-edit-tools {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 1 0 100%;
    }

    .context-nav-main-rating ::v-deep {
        .rating-nav {
            button.dropdown-toggle {
                color: $white !important;
                background-color: $primary;
                padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'fifteen');
            }

            .edit-rating-title {
                font-size: $default-font-size;

                i,
                &:before {
                    color: $primary;
                }

                .dropdown-item {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: map-get($grid-gutter-spacing, 'eight');
                        font-size: $base-font-size;
                    }
                }
            }

            .dropdown-menu {
                border: 1px solid $border-color;

                li {
                    &:before,
                    i {
                        width: 20px;
                    }
                }
            }
        }
    }

    &:hover {
        cursor: pointer;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .rating-edit-header {
        flex-wrap: nowrap;

        .title {
            width: calc(100% - 95px);
        }

        .rating-edit-tools {
            flex: 0 1 auto;
            margin-left: auto;
            align-self: baseline;
        }
    }
}
</style>
